import { useMemo, useRef } from 'react';
import { Vector3 } from 'three';
import { useFrame } from '@react-three/fiber';
import { DIRS } from '../utils/constants';
import random from '../utils/random';
import { computeBoundingbox } from '../utils/element';
import { getCoord } from '../utils/scene';
import vertority from '../utils/vertority';
export const useSnowflakes = ({ count = 100 } = { count: 100 }) => {
    const snowflakes = useMemo(() => {
        const coord = getCoord();
        return new Array(4).fill(0).reduce((prev, _cur, i) => {
            return prev.concat(new Array(Math.round(count / 4)).fill(0).map(() => {
                const vertor = vertority.fromPlacement('fromTop');
                return {
                    startpoint: new Vector3().copy(new Vector3(0, coord[1] + i * 2, 0)).add(vertor),
                    radius: Math.random() * 0.1,
                };
            }));
        }, []);
    }, [count]);
    return {
        snowflakes: snowflakes,
    };
};
export const useSnowflake = (flake, { value }) => {
    const vy0 = useRef(0.01);
    const coord = useRef(getCoord()).current;
    // vy0 / vx0 = tan(angle)
    const vx0 = useRef(0.001 * Math.random() * random.inRange(DIRS));
    // const a = useRef(0.00001)
    const { offsetTop } = computeBoundingbox(value.startpoint);
    useFrame(() => {
        if (!flake.current) {
            return;
        }
        // 雪花加速下落
        flake.current.position.y -= vy0.current;
        flake.current.position.x -= vx0.current;
        // 判断是否出了边界
        if (offsetTop + Math.abs(value.startpoint.y - flake.current.position.y) > coord[1] * 2) {
            const vertor = vertority.fromAxis('fromTop');
            // 随机raindrop初始位置, 避免loop重复
            flake.current.position.set(vertor.x, vertor.y + coord[1], vertor.z);
            vy0.current = 0.01;
            vx0.current = 0.001 * Math.random() * random.inRange(DIRS);
        }
    });
};
